import { Controller } from 'stimulus';
import { form } from 'formifier';
import { errorMessages } from '../src/js/formifier_error_messages/error_messages';

class FormController extends Controller {
  static targets = ['form'];

  connect() {
    if (this.formTargets.length) {
      form(errorMessages, this.formTarget);
    }
  }
}

export default FormController;
